<template>
  <div class="pb-3">
    <form class="form-group hrflowSearchContainer pt-3">
      <!-- <label
        class="form-control-label"
      >
        Language(s)
      </label>
      <InputTag
        add-tag-on-blur
        v-model="model.languages"
        class="w-100 mb-3"
        style="border-radius: 0.3rem;"
        tabindex="3"
      /> -->
      <div class="textOnInput">
        <label
          class="form-control-label"
        >
          Name(s)
        </label>
        <InputTag
          add-tag-on-blur
          v-model="model.names"
          class="w-100 mb-3"
          style="border-radius: 0.3rem;"
          tabindex="4"
        />
      </div>
      <div class="textOnInput">
        <label
          class="form-control-label"
        >
          Skill(s)
        </label>
        <InputTag
          add-tag-on-blur
          v-model="model.skills"
          class="w-100 mb-3"
          style="border-radius: 0.3rem;"
          tabindex="4"
        />
      </div>
  
      <div class="textOnInput">
        <label
          class="form-control-label"
        >
          Tag(s) Included
        </label>
        <InputTag
          add-tag-on-blur
          v-model="model.tags_included"
          class="w-100 mb-3"
          style="border-radius: 0.3rem;"
          tabindex="4"
        />
      </div>
  
      <div class="textOnInput">
        <label
          class="form-control-label"
        >
          Tag(s) Excluded
        </label>
        <InputTag
          add-tag-on-blur
          v-model="model.tags_excluded"
          class="w-100 mb-3"
          style="border-radius: 0.3rem;"
          tabindex="4"
        />
      </div>
      <div class="w-100 d-flex justify-content-between align-items-center flex-row mb-3 textOnInput">
        <div class="col-6 p-0 pr-1">
          <label
            class="form-control-label"
          >
            Start Date
          </label>
          <flat-pickr
            v-model="model.created_at_min"
            class="form-control flatpicker"
          />
        </div>
        <div class="col-6 p-0 pl-1">
          <label
            class="form-control-label"
          >
            End Date
          </label>
          <flat-pickr
            v-model="model.created_at_max"
            class="form-control flatpicker"
          />
        </div>
      </div>
      <!-- <Select
        autoload
        class="w-100"
        label="Order by"
        textField="text"
        valueField="value"
        :name.sync="model.order_by"
        moduleName="order_by"
        v-model="model.order_by"
      /> -->
  
    </form>
    <div v-if="hasButton" class="row reverse justify-content-end w-100">
      <button
        label="Reset"
        class="px-4 py-1 btn2 btn2-secondary btn2-sm"
        @click="onReset" 
      >Reset</button>
      <button
        type="submit"
        label="Search"
        class="px-4 py-2 ml-1 btn2 btn2-primary btn2-sm"
        @click="onSearch" 
      >Search</button>
    </div>
  </div>
</template>

<script>
// import TextField from '@components/form/textfield'
// import Select from '@components/form/select'

import InputTag from 'vue-input-tag'

export default {
  components: {
    InputTag,
    // TextField,
    // Select
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    },
    hasButton: Boolean
  },
  data() {
    return {
      model: {
        languages: [],
        skills: [],
        order_by: 'asc'
      }
    }
  },
  methods: {
    onSearch() {
      this.$emit('onSearchField', this.model)
    },
    onReset() {
      this.model = {
        languages: [],
        skills: [],
        order_by: 'asc',
      }
      this.onSearch()
    }
  }
}
</script>
<style lang="scss">
  .hrflowSearchContainer {
    // max-height: 65vh;
    // overflow: auto;
  }
</style>
